module.exports = __webpack_public_path__ + "img/ganimal.83c4e07.webp";